/**
 * Translates hex colors to RGBA so we can make Chrono-UI colors semi-transparent when necessary:
 */
export const hexToRgba = (hex: string, alpha: number | undefined = 1) => {
  const [r, g, b] = hexToRgbValues(hex);
  return `rgba(${r}, ${g}, ${b}, ${alpha})`;
};

export type RgbColor = [red: number, green: number, blue: number];

/**
 * Translates hex colors to RGB values.
 */
export const hexToRgbValues = (hex: string): RgbColor => {
  const hexWithoutHash = hex.replace('#', '');

  const fullHex = hexWithoutHash.length === 3 ? `${hexWithoutHash}${hexWithoutHash}` : hexWithoutHash;

  const [r, g, b] = fullHex
    .split(/(..)/)
    .filter((c) => c)
    .map((c) => parseInt(c, 16));

  return [r ?? 0, g ?? 0, b ?? 0];
};
